<style>
    legend.scheduler-border {
        width: inherit; /* Or auto */
        padding: 0 10px; /* To give a bit of padding on the left and right */
        border-bottom: none;
    }
</style>
<template>
    <div>
        <!--<div v-show="controller.isEditing">
            <forminput :controller="controller.addressType"></forminput>
            <forminput :controller="controller.addressLine"></forminput>
            <forminput :controller="controller.postCode"></forminput>
            <forminput :controller="controller.town"></forminput>
            <forminput :controller="controller.county"></forminput>
            <forminput :controller="controller.country"></forminput>

            <button class="col-md-offset-3 btn btn-default" @click.prevent.self="controller.isEditing = false">Done</button>
        </div>
        <div v-show="!controller.isEditing">
            <div class="col-md-offset-3">
                <p class="text-primary"><strong>{{controller.addressType.value}} </strong>  </p>
                <p>{{controller.addressLine.value}}   </p>
                <p>{{controller.town.value}}         {{controller.postCode.value}}      </p>
                <p>{{controller.county.value}}        </p>
            </div>
            <button class="col-md-offset-3 btn btn-default" @click.prevent.self="controller.isEditing = true">Update</button>
        </div>-->
    </div>
</template>
<script>
    import forminput from "./../../corecontrols/forminput/forminput.scp.html"
    import { AddressEditorController } from './addressEditorController'
    import { AddressDto } from './../../../dto/address'


    export default {
        props: ['address'],

        data: function () {
            return {
                controller: new AddressEditorController(new AddressDto())
            }
        },
        mounted: function () {
            if (this.address) {
                this.controller = new AddressEditorController(this.address)
            }
        },
        components: {
            forminput
        }
    }
</script>




// WEBPACK FOOTER //
// addressEditor.scp.html?1fe1b579